import { Component, OnDestroy, OnInit,ViewChild,ElementRef } from '@angular/core';
import { Subscription,interval } from 'rxjs';
import { TokenExpiryService } from 'src/app/service/token-expiry.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-token-expiry-notification',
  templateUrl: './token-expiry-notification.component.html',
  styleUrls: ['./token-expiry-notification.component.scss']
})
export class TokenExpiryNotificationComponent implements OnInit, OnDestroy {

  notification: string | null = null;
  private subscription: Subscription;
  @ViewChild('sessionExpiry') sessionExpiryPopUp: ElementRef | undefined;
  public minutes: number = 10;
  public seconds: number = 0;

  constructor(private notificationService: TokenExpiryService,private modalService: NgbModal,private router: Router) {}

  ngOnInit() {
    this.subscription = this.notificationService.getNotifications().subscribe(message => {
      this.notification = message;
      this.startTimer();
      this.modalService.open(this.sessionExpiryPopUp);
    });
  }

  startTimer() {
    const source = interval(1000);
    this.subscription = source.subscribe(val => {
      if (this.seconds === 0) {
        if (this.minutes === 0) {
          this.subscription.unsubscribe();
          this.router.navigateByUrl('/unauthorizedAccess');
          this.modalService.dismissAll();
        } else {
          this.minutes--;
          this.seconds = 59;
        }
      } else {
        this.seconds--;
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
